import { MinusCircleMultipleOutlineIcon } from './MinusCircleMultipleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 313B60B3-A740-4F5B-A63E-A5772C20AC0D
 * name minus-circle-multiple-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-circle-multiple-outline.svg
 * tags
 * - Form 
 */
export const CoinsMinusOutlineIcon = MinusCircleMultipleOutlineIcon;
export default CoinsMinusOutlineIcon